import dayjs from '~/timeInit';

export type VoucherUserExpiryLongDurationMode = 'date' | 'days';

/**
 * True when user expiry is strictly longer than 12 calendar months from today:
 * — fixed date mode: expiry calendar day is after `today + 12 months`
 * — days mode: whole days from assignment exceed whole days until `today + 12 months`
 */
export function isVoucherUserExpiryOverTwelveMonths(options: {
  mode: VoucherUserExpiryLongDurationMode;
  voucherUserExpiresAt: string;
  voucherUserExpiresInDays: string;
}): boolean {
  const { mode, voucherUserExpiresAt, voucherUserExpiresInDays } = options;
  const startOfToday = dayjs().startOf('day');
  const endOfTwelveMonths = startOfToday.add(12, 'month');

  if (mode === 'date') {
    const at = voucherUserExpiresAt.trim();
    if (!at) {
      return false;
    }
    const datePart = at.length >= 10 ? at.slice(0, 10) : at;
    const expiry = dayjs(datePart).startOf('day');
    if (!expiry.isValid()) {
      return false;
    }
    return expiry.isAfter(endOfTwelveMonths, 'day');
  }

  const trimmed = voucherUserExpiresInDays.trim();
  if (!trimmed) {
    return false;
  }
  const parsed = Number.parseInt(trimmed, 10);
  if (Number.isNaN(parsed)) {
    return false;
  }
  const maxDaysWithinTwelveMonths = endOfTwelveMonths.diff(startOfToday, 'day');
  return parsed > maxDaysWithinTwelveMonths;
}
